const SWATCH_LAYOUT_SETTINGS = {
    6: {
        countPerBlock: 5,
        blocksPerPage: 6
    },
    8: {
        countPerBlock: 6,
        blocksPerPage: 8
    }
};

function getLayoutSettings(gataSu) {
    const settings = SWATCH_LAYOUT_SETTINGS[Number(gataSu)];

    if (!settings) {
        throw new RangeError('gataSu must be 6 or 8.');
    }

    return settings;
}

function toCount(value) {
    const count = Number(value);
    return Number.isFinite(count) ? count : 0;
}

export function calculateSwatchBlockCount(colorCount, sizeCount, gataSu) {
    const { countPerBlock, blocksPerPage } = getLayoutSettings(gataSu);
    const colorBlocks = Math.ceil(toCount(colorCount) / countPerBlock);
    const sizeBlocks = Math.ceil(toCount(sizeCount) / countPerBlock);
    const blockCount = colorBlocks * sizeBlocks;

    return Math.max(1, Math.min(blockCount, blocksPerPage));
}

export function recalculateSwatchLayout(details, gataSu) {
    const { blocksPerPage } = getLayoutSettings(gataSu);
    let pageNo = 1;
    let columnNo = 1;
    let positionNo = 1;

    return details.map(detail => {
        if (detail.SWT_OPPICD === null || detail.SWT_OPPICD === undefined || String(detail.SWT_OPPICD).trim() === '') {
            return { ...detail };
        }

        const blockCount = calculateSwatchBlockCount(detail.COLORCOUNT, detail.SIZECOUNT, gataSu);

        if (columnNo + blockCount - 1 > blocksPerPage) {
            pageNo += 1;
            columnNo = 1;
            positionNo = 1;
        }

        const result = {
            ...detail,
            SWT_GATASU: blocksPerPage,
            SWT_PAGENO: pageNo,
            SWT_COLUMNNO: columnNo,
            SWT_POSITIONNO: positionNo
        };

        columnNo += blockCount;
        positionNo += blockCount;

        return result;
    });
}
